import { Injectable } from '@angular/core';
import { ConfigService } from '@services/webFeeder/config.service';
import { WebFeederFactory } from '@connections/web-feeder.factory';
import { environment } from 'src/environments/environment';
import { StatusConnection } from '@model/status-connection';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { AppUtils } from '@utils/app.utils';
import { SystemServiceErrorCodKeyEnum, SystemServiceErrorEnum } from '@model/enum/system-services-error-msg';
import { Subject, BehaviorSubject } from 'rxjs';
import {AuthenticationService} from '../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private subject: Subject<MessageEvent>;
  private url: string;
  private numberReconect = 1;
  private isConnected = false;
  private isReconnected = false;
  private isLogout = false;
  private setLoadingWks = false;
  private _statusWebSocket = new BehaviorSubject<number>(StatusConnection.INITIAL);
  statusWebSocket$ = this._statusWebSocket.asObservable();
  private _numberReconect = new BehaviorSubject<number>(0);
  numberReconect$ = this._numberReconect.asObservable();
  private _reconectSocket = new BehaviorSubject<boolean>(false);
  reconectSocket$ = this._reconectSocket.asObservable();
  private _statusWFLogin = new BehaviorSubject<boolean>(true);
  statusWFLogin$ = this._statusWFLogin.asObservable();
  private _statusWFOnError = new BehaviorSubject<number>(StatusConnection.INITIAL);
  _statusWFOnError$ = this._statusWFOnError.asObservable();
  private services = {};
  bypassDisconectionValidation: boolean;
  numberSnapDailyOrder: number;
  timeoutReconnectWF: any;

  constructor(
    private configService: ConfigService,
    private modalService: MatDialog,
    // private authenticationService: AuthenticationService
  ) {
    this.configService.resetNumberSnapDaily$.subscribe(res => res ? this.numberSnapDailyOrder = 0 : this.numberSnapDailyOrder);
  }

  public connect(url?: string) {
    if (!WebFeederFactory.existsWS(this.configService.getUrlWebSocketWebFeeder(this.numberReconect))) {
      this.url = url ?? this.configService.getUrlWebSocketWebFeeder(this.numberReconect);
      this.configService.writeLog('\nSOCKET SERVICE > -----------------------------------------------------------');
      this.configService.writeLog('SOCKET SERVICE > CONNECT - WS: [' + this.url + '][' + this.numberReconect + ']');
      this.configService.writeLog('SOCKET SERVICE > -----------------------------------------------------------\n');
      this.subject = this.create(this.url);
    }
  }

  public register(obsService: any) {
    if (!this.services[obsService.name]) {
      this.services[obsService.name] = obsService;
    }
  }

  public signService(message) {
    if (this.subject) {
      this.subject.next(message);
    }
  }

  public disconnect(isTemporaryDisconection?: boolean) {
    if (isTemporaryDisconection) { // verify if is a proposital disconection
      this.bypassDisconectionValidation = isTemporaryDisconection;
    }
    this.configService.writeLog('\nSOCKET SERVICE > disconnect : [' + this.url + ']');
    WebFeederFactory.closeAllConnections();
    WebFeederFactory.closeWebFeeder(this.url);
  }

  public logout() {
    this.configService.writeLog('\nSOCKET SERVICE > logout : [' + this.url + ']');
    console.log('\nSOCKET SERVICE > logout : [' + this.url + ']');
    this.isLogout = true;
    WebFeederFactory.closeWebFeeder(this.url);
    WebFeederFactory.closeAllConnections();
  }

  private create(url): Subject<MessageEvent> {
    let observer: any;
    this.numberSnapDailyOrder = 0;
    try {
      const ws = WebFeederFactory.getWebFeederConnection(url, this.isReconnected);
      this.configService.writeLog('\nSOCKET SERVICE > create: [' + url + ']');
      ws.onopen = () => {
        this.isLogout = false;
        this.configService.writeLog('SOCKET SERVICE > onOpen');
        this._statusWebSocket.next(StatusConnection.SUCCESS);
        this._numberReconect.next(0);
        this.isConnected = true;
        if (this.isReconnected) {
          this.configService.writeLog('SOCKET SERVICE > SUCCESS_RECONNECT');
          this.isReconnected = false;
          this._statusWebSocket.next(StatusConnection.SUCCESS_RECONNECT);
          this.numberReconect = 0;
          setTimeout(() => {
            location.reload();
          }, 10);
        }
        this.bypassDisconectionValidation = false;
      };

      ws.onclose = () => {
        this.configService.writeLog('SOCKET SERVICE > onClose');
        if (!this.isLogout) {
          this.isConnected = false;
          if (!this.bypassDisconectionValidation) {
            this._statusWebSocket.next(StatusConnection.ERROR);
          }
          this.timeoutReconnectWF = setTimeout(() => {
            if (this.configService.isAuthenticadSystem()) {
              this.configService.writeLog('SOCKET SERVICE > TIMEOUT > Reconnect');
              this.onReconnect();
            } else {
              clearTimeout(this.timeoutReconnectWF);
            }
          }, environment.RECONNECT_INTERVAL);
        }
      };

      ws.onerror = (evt) => {
        this.configService.writeLog('SOCKET SERVICE > onError');
        this.configService.writeError(evt);
        this.configService.writeLog('', 'HOME > ngOnInit() > Erro ao conectar no WEBFEEDER');
        this._statusWebSocket.next(StatusConnection.ERROR);
      };

      ws.onmessage = (event) => {
        try {
          const answer = JSON.parse(event.data);
          if (answer && answer.code && answer.message) {
            this.configService.writeLog('SOCKET QUOTE > code: ' + answer.code + ' - message: ' + answer.message);
            if (answer.code === Constants.WF_SERVICE_LOGIN_ERROR_CODE) {
              this.disconnect();
              this._statusWFLogin.next(false);
              this.modalService.closeAll();
            }
            if (answer.code === Constants.WF_SERVICE_ERROR_CODE) {
              this._statusWFOnError.next(StatusConnection.ERROR);
            }
          }
          if (answer && answer.token !== undefined && answer.success === true) {
            this.configService.setTokenWS(answer.token);
            return null;
          }
          if (this.services[answer.type]) {
            this.services[answer.type].serviceSubject.next(answer);
            if (this.services[answer.type].name === 'dailyOrder') {
              if (answer.listBeans && answer.listBeans.length > 0) {
                this.numberSnapDailyOrder++;
                const isRefreshPage = this.configService.getRefreshPage();
                if ((!isRefreshPage || isRefreshPage === 'false') || (isRefreshPage === 'true' && this.numberSnapDailyOrder !== 1)) {
                  this.systemNotificationDailyOrder(answer.listBeans);
                }
              }
            }
          } else {
            for (const key of Object.keys(this.services)) {
              if (this.services[key].fn && this.services[key].fn(answer)) {
                this.services[key].serviceSubject.next(answer);
                return;
              }
            }
          }
        } catch (err) {
          this.configService.writeLog('SOCKET SERVICE > onmessage > error converting message' + err);
        }
      };
      observer = {
        next: (data: Object) => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify(data));
          } else {
            let status = '-';
            if (ws.readyState === WebSocket.CLOSED) {
              status = 'CLOSED';
              this.configService.writeLog('SOCKET SERVICE > readyState: [' + ws.readyState + '][' + status + ']');
            } else if (ws.readyState === WebSocket.CLOSING) {
              status = 'CLOSING';
              this.configService.writeLog('SOCKET SERVICE > readyState: [' + ws.readyState + '][' + status + ']');
            } else if (ws.readyState === WebSocket.CONNECTING) {
              status = 'CONNECTING';
              this.configService.writeLog('SOCKET SERVICE > readyState: [' + ws.readyState + '][' + status + ']');
            }
            this.configService.writeLog('SOCKET SERVICE > readyState: [' + ws.readyState + '][' + status + ']');
          }
          if (ws.readyState === WebSocket.OPEN && !this.setLoadingWks) {
            this.configService.writeLog('SOCKET SERVICE > readyState: [' + ws.readyState + '][' + 'CONECTADO' + ']');
            this._reconectSocket.next(true);
            this.setLoadingWks = true;
          }
        }
      };
    } catch (e) {
      this.configService.writeError('Error: criar conexão do ws');
    }
    return Subject.create(observer);
  }

  private onReconnect() {
    try {
      if (!this.isConnected) {
        this.isReconnected = true;
        this.numberReconect = this.numberReconect + 1;
        this.url = this.configService.getUrlWebSocketWebFeeder(this.numberReconect);
        this.configService.writeLog('\nSOCKET SERVICE > ---------------------------------------------------------------------------------');
        this.configService.writeLog('SOCKET SERVICE > onReconnect: [' + this.url + '][' + this.numberReconect + ']');
        this.configService.writeLog('SOCKET SERVICE > ---------------------------------------------------------------------------------\n');
        this._numberReconect.next(this.numberReconect);
        if (this.numberReconect >= environment.RECONECT_ATTEMPTS) {
          this.configService.writeLog('\nSOCKET SERVICE > -------------------------------------------------------------------------------');
          this.configService.writeLog('SOCKET SERVICE > NUMERO MAXIMO DE TENTATIVAS DE CONEXAO COM WEB SOCKET. VERIFICAR SUA CONEXÃO COM A INTERNET.');
          this.configService.redirectExpireSession(Constants.ERROR_WF_CONECTION_RECONNECT, Constants.ERROR_WF_CONECTION_RECONNECT2, SystemServiceErrorEnum.onReconnectSocket,
            SystemServiceErrorCodKeyEnum.error, Constants.ERROR_EXPIRED_ICON);
          this.configService.writeLog('SOCKET SERVICE > -------------------------------------------------------------------------------\n');
        } else {
          if (this.subject) {
            this.subject.unsubscribe();
          }
          this.subject = undefined;
          if (!this.configService.getHideMessageDisconectSocket()) {
            this.callAlert('', Constants.ERROR_WF_CONECTION_TEXT.replace('QTD', this.numberReconect.toString()), Constants.ALERT_TYPE.info);
          }
          this.configService.deleteHideMessageDisconectSocket();
          this.configService.writeLog('SOCKET SERVICE > CONNECT - WS: [' + this.url + '][' + this.numberReconect + ']');
          this.create(this.url);
        }
      }
    } catch (e) {
      this.configService.writeError(e);
    }
  }

  public getConnected() {
    return this.isConnected;
  }

  public dispose() {
    if (this.subject) {
      this.subject.unsubscribe();
    }
  }

  private systemNotificationDailyOrder(order) {
    if (order && order.length > 0) {
      order.forEach(orderTemp => {
        const orderID = orderTemp?.orderID?.value ?? '';
        const quote = orderTemp?.quote?.value ?? '';
        const stateCode = orderTemp?.state?.code ?? '';
        const stateValue = orderTemp?.state?.value ?? '';
        const massStatusReqID = orderTemp?.massStatusReqID?.value ?? '';
        const notifica = (stateCode && massStatusReqID === '' && stateValue.toLowerCase().indexOf('pend') !== 0) ? 'SIM' : 'NAO';

        this.configService.writeLog('SOCKET SERVICE > systemNotificationDailyOrder > ID: ' + orderID
          + ' | ATIVO: ' + quote
          + ' | Notifica: ' + notifica
          + ' | Status: [' + stateCode + '] ' + stateValue);

        if (
          stateCode &&
          massStatusReqID === '' &&
          stateValue.toLowerCase().indexOf('pend') !== 0
        ) {
          const status = Constants.ORDER_HISTORY_STATUS_WF.find(x => x.code === orderTemp.state.code);
          if (status && status.message) {
            let message = status.message
              .replace('[SIDE]', orderTemp.side.value)
              .replace('[QUOTE]', orderTemp.quote.value)
              .replace('[ID]', orderTemp.orderID.value)
              .replace('[PREÇO_EXECUCAO]', orderTemp.price.value && orderTemp.mercado.code
                ? AppUtils.formatPriceBovespaAndBmfToString(orderTemp.price.value, orderTemp.mercado.code) : orderTemp.price.value)
              .replace('[QTD_EXECUTADA]', orderTemp.quantityExecuted.value)
              .replace('[QTD_TOTAL]', orderTemp.quantitySupplied.value);
            if (status.code === '8') {
              if (orderTemp.text.value) {
                message += '<br>Motivo: ' + orderTemp.text.value;
                status.alert = Constants.ALERT_TYPE.error_reject;
              } else {
                status.alert = Constants.ALERT_TYPE.error;
              }
            }
            this.callAlert('', message, status.alert);
          }
        }
      });
    }
  }

  callAlert(title, message, typeAlert) {
    this.configService.systemNotificationMessage(title, message, typeAlert);
  }

}
